var map = {
	"./add-circle.svg": 351163,
	"./add-tag.svg": 657849,
	"./alarm.svg": 32476,
	"./album.svg": 762922,
	"./amazon-music-logo.svg": 170545,
	"./amex-icon.svg": 456994,
	"./apple-logo.svg": 244357,
	"./apple-music-logo.svg": 880087,
	"./arrow-down.svg": 474373,
	"./arrow-left-big-v2.svg": 955004,
	"./arrow-right-big-v2.svg": 737017,
	"./arrow-right-big.svg": 249736,
	"./arrow-right-compact.svg": 626041,
	"./arrow-right.svg": 186813,
	"./attachment.svg": 389726,
	"./auto-tag.svg": 111043,
	"./bandcamp-logo.svg": 670061,
	"./box.svg": 605800,
	"./browse.svg": 941623,
	"./business-center.svg": 922951,
	"./calendar.svg": 821215,
	"./cancel.svg": 855211,
	"./check-circle.svg": 375440,
	"./check-in-star.svg": 131134,
	"./check-outline.svg": 918614,
	"./check.svg": 262579,
	"./checkbox.svg": 384978,
	"./chevron-left.svg": 963840,
	"./chevron-right.svg": 641967,
	"./clear.svg": 908584,
	"./close.svg": 786695,
	"./comment.svg": 826096,
	"./comments.svg": 39603,
	"./contact-mail.svg": 476361,
	"./contract.svg": 172043,
	"./copy.svg": 206786,
	"./crisis-alert.svg": 104763,
	"./dashboard/downtrend.svg": 218847,
	"./dashboard/uptrend.svg": 514674,
	"./delete-bucket.svg": 507355,
	"./disco-bolt.svg": 245015,
	"./disco-logo-square.svg": 931773,
	"./disco-mark.svg": 418753,
	"./disco-track.svg": 763443,
	"./down-arrow.svg": 85733,
	"./down.svg": 26881,
	"./download-arrow.svg": 733253,
	"./download-embed.svg": 229893,
	"./download-track.svg": 284371,
	"./download.svg": 401313,
	"./drop-zone.svg": 520945,
	"./dropbox.svg": 206473,
	"./edit-document.svg": 978189,
	"./edit-large.svg": 313959,
	"./edit.svg": 663737,
	"./ellipsis-vertical.svg": 752807,
	"./email-draft.svg": 858953,
	"./email-scheduled.svg": 751185,
	"./email-sent.svg": 977538,
	"./empty-calendar.svg": 702755,
	"./error.svg": 291029,
	"./expand.svg": 874661,
	"./external-link.svg": 226277,
	"./facebook-logo.svg": 513079,
	"./file-download.svg": 613972,
	"./filter.svg": 428683,
	"./folder-outline.svg": 696436,
	"./folder.svg": 915041,
	"./format-csv.svg": 201003,
	"./format-list.svg": 312237,
	"./format-pdf.svg": 231677,
	"./format-spreadsheet.svg": 693481,
	"./format-unknown.svg": 348301,
	"./google-drive.svg": 873199,
	"./header-menu.svg": 537114,
	"./heart.svg": 820935,
	"./help.svg": 629988,
	"./image-add.svg": 132338,
	"./imdb-pro-logo.svg": 377129,
	"./inbox.svg": 941583,
	"./info-outline.svg": 569796,
	"./info.svg": 587953,
	"./instagram-logo.svg": 846801,
	"./invite.svg": 163326,
	"./libraries.svg": 64582,
	"./library-black.svg": 425780,
	"./library-music.svg": 800420,
	"./library-white.svg": 566962,
	"./link.svg": 620521,
	"./load.svg": 955677,
	"./loading-indicator.svg": 456975,
	"./loading-login.svg": 662699,
	"./loading.svg": 964099,
	"./lock-open.svg": 390841,
	"./lock.svg": 543616,
	"./lyrics.svg": 790033,
	"./mail-send.svg": 821163,
	"./mastercard-icon.svg": 714969,
	"./media-player.svg": 521531,
	"./menu.svg": 190632,
	"./merge.svg": 477959,
	"./minus.svg": 567111,
	"./music-note.svg": 560343,
	"./nav-close.svg": 977663,
	"./nav-open.svg": 999361,
	"./new-playlist.svg": 378696,
	"./not-found.svg": 215243,
	"./note1.svg": 117342,
	"./note2.svg": 263613,
	"./notification-important.svg": 344661,
	"./notification.svg": 64808,
	"./noun_302900.svg": 151586,
	"./noun_302903.svg": 315633,
	"./one-drive.svg": 626304,
	"./open-in-new-tab-circle.svg": 64573,
	"./open-in-new-tab.svg": 724080,
	"./pause-v2.svg": 23642,
	"./pause.svg": 215093,
	"./pen.svg": 709702,
	"./person-add.svg": 433412,
	"./pin-circle.svg": 591975,
	"./play-v2.svg": 219560,
	"./play-v3.svg": 731929,
	"./play-v4.svg": 575094,
	"./play.svg": 820703,
	"./player-menu/add-to-channel.svg": 294330,
	"./player-menu/add-to-new-channel.svg": 471467,
	"./player-menu/add-to-shortlist.svg": 241357,
	"./player-menu/delete-track.svg": 865162,
	"./player-menu/download-track.svg": 330095,
	"./player-menu/edit-metadata.svg": 978281,
	"./player-menu/get-url.svg": 829555,
	"./player-menu/permissions.svg": 885671,
	"./player-next.svg": 736844,
	"./player-pause.svg": 188107,
	"./player-play.svg": 58053,
	"./player-playlist.svg": 901101,
	"./player-prev.svg": 35852,
	"./player-volume.svg": 939497,
	"./playlist-add.svg": 653389,
	"./playlist-black.svg": 302053,
	"./playlist-circle.svg": 4312,
	"./playlist-v2.svg": 656396,
	"./playlist-white.svg": 906091,
	"./playlist.svg": 345243,
	"./plus-white.svg": 289997,
	"./plus.svg": 345481,
	"./pre-release.svg": 923708,
	"./profile.svg": 874088,
	"./profiles.svg": 287131,
	"./qobuz-logo.svg": 837492,
	"./qr.svg": 117824,
	"./reload.svg": 588170,
	"./saved-to-disco.svg": 401989,
	"./search-v2.svg": 645898,
	"./search.svg": 399877,
	"./section.svg": 934926,
	"./send.svg": 807419,
	"./share.svg": 350026,
	"./shortlist-toggle-v2.svg": 490927,
	"./shortlist-toggle.svg": 703266,
	"./soundcloud-logo.svg": 223023,
	"./soundwave.svg": 762213,
	"./spotify-logo.svg": 616835,
	"./star-in-box.svg": 579683,
	"./star-v2.svg": 881766,
	"./star.svg": 741721,
	"./starred.svg": 83270,
	"./stash.svg": 498848,
	"./stats-lite.svg": 602131,
	"./stats.svg": 729686,
	"./status-check.svg": 697644,
	"./status-cross.svg": 934172,
	"./tag-add.svg": 719089,
	"./tag-circle.svg": 782708,
	"./tag-remove.svg": 736408,
	"./tag.svg": 637975,
	"./tags-add.svg": 351828,
	"./thread-white.svg": 275801,
	"./thumbs-up.svg": 679600,
	"./tidal-logo.svg": 91817,
	"./tiktok-logo.svg": 341449,
	"./track-black.svg": 92784,
	"./track-circle.svg": 991919,
	"./track-white.svg": 389742,
	"./track.svg": 94210,
	"./trash.svg": 143233,
	"./trending-up.svg": 402512,
	"./trial-timer.svg": 195859,
	"./twitter-logo.svg": 433870,
	"./uncheck.svg": 768544,
	"./up-arrow.svg": 772026,
	"./upload-file.svg": 805393,
	"./upload.svg": 572662,
	"./user-circle.svg": 916369,
	"./user.svg": 89860,
	"./warning.svg": 255403,
	"./watch.svg": 259658,
	"./watermarking-logo.svg": 576553,
	"./watermarking.svg": 395531,
	"./wave.svg": 744906,
	"./website-logo.svg": 790932,
	"./world.svg": 99884,
	"./youtube-logo.svg": 520252,
	"./zoom-in.svg": 930196,
	"./zoom-out.svg": 836987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10451;